import { PERMISSIONS } from '@shared/permissions/permissions';
import { createFileRoute, Outlet } from '@tanstack/react-router';
import { ClipboardCheck } from 'lucide-react';

// Pass-through layout carrying the access gates for the WHOLE compliance-audit
// tree (overview tabs AND the details pages outside ~overview). Route metadata
// is merged across matched routes, so the flag / module / permission here is
// what hides the left-nav item and gates every child path.
export const Route = createFileRoute('/console/$orgId/tools/compliance-audit')({
    staticData: {
        breadcrumb: {
            title: 'Compliance audit',
        },
        featureFlag: 'enable-compliance-audit',
        modules: ['compliance-audit'],
        permissions: [PERMISSIONS.COMPLIANCE_AUDIT_ACCESS],
        ui: {
            icon: ClipboardCheck,
        },
    },
    component: Outlet,
});
